export const SET_COUNTER_VALUE = "SET_COUNTER_VALUE";